module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "default_right.a801c0cc.svg";